import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FontAwesomeLoader from './components/FontAwesomeLoader';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Career from './pages/Career';
import Events from './pages/Events';
import EliteBuyerClub from './pages/EliteBuyerClub';
import News from './pages/News';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ModalsContainer from './components/modals/ModalsContainer';
import './App.css';

const AppContent = () => {
  const location = useLocation();

  return (
    <div className="App">
      <FontAwesomeLoader />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/events" element={<Events />} />
          <Route path="/elite-buyer-club" element={<EliteBuyerClub />} />
          <Route path="/Elite-buyer-club" element={<EliteBuyerClub />} />
          <Route path="/news" element={<News />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
      <ModalsContainer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

